/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useMutation } from 'react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type {
  DateTimeRangeRequest,
  TransactionsPollRequest,
} from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const insertHsbcMaintenanceWindow = (
  dateTimeRangeRequest: DateTimeRangeRequest
) => {
  return customInstance<void>({
    url: `/operations/hsbc/statement/maintenance/window`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dateTimeRangeRequest,
  });
};

export const getInsertHsbcMaintenanceWindowMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof insertHsbcMaintenanceWindow>>,
    TError,
    { data: DateTimeRangeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof insertHsbcMaintenanceWindow>>,
  TError,
  { data: DateTimeRangeRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof insertHsbcMaintenanceWindow>>,
    { data: DateTimeRangeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return insertHsbcMaintenanceWindow(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InsertHsbcMaintenanceWindowMutationResult = NonNullable<
  Awaited<ReturnType<typeof insertHsbcMaintenanceWindow>>
>;
export type InsertHsbcMaintenanceWindowMutationBody = DateTimeRangeRequest;
export type InsertHsbcMaintenanceWindowMutationError = unknown;

export const useInsertHsbcMaintenanceWindow = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof insertHsbcMaintenanceWindow>>,
    TError,
    { data: DateTimeRangeRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof insertHsbcMaintenanceWindow>>,
  TError,
  { data: DateTimeRangeRequest },
  TContext
> => {
  const mutationOptions =
    getInsertHsbcMaintenanceWindowMutationOptions(options);

  return useMutation(mutationOptions);
};
export const pollTransactions = (
  transactionsPollRequest: TransactionsPollRequest
) => {
  return customInstance<void>({
    url: `/operations/hsbc/statement/transactions/poll`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: transactionsPollRequest,
  });
};

export const getPollTransactionsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pollTransactions>>,
    TError,
    { data: TransactionsPollRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pollTransactions>>,
  TError,
  { data: TransactionsPollRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pollTransactions>>,
    { data: TransactionsPollRequest }
  > = (props) => {
    const { data } = props ?? {};

    return pollTransactions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PollTransactionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof pollTransactions>>
>;
export type PollTransactionsMutationBody = TransactionsPollRequest;
export type PollTransactionsMutationError = unknown;

export const usePollTransactions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pollTransactions>>,
    TError,
    { data: TransactionsPollRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof pollTransactions>>,
  TError,
  { data: TransactionsPollRequest },
  TContext
> => {
  const mutationOptions = getPollTransactionsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const pollDailyTransactions = (
  transactionsPollRequest: TransactionsPollRequest
) => {
  return customInstance<void>({
    url: `/operations/hsbc/statement/transactions/poll/daily`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: transactionsPollRequest,
  });
};

export const getPollDailyTransactionsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pollDailyTransactions>>,
    TError,
    { data: TransactionsPollRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pollDailyTransactions>>,
  TError,
  { data: TransactionsPollRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pollDailyTransactions>>,
    { data: TransactionsPollRequest }
  > = (props) => {
    const { data } = props ?? {};

    return pollDailyTransactions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PollDailyTransactionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof pollDailyTransactions>>
>;
export type PollDailyTransactionsMutationBody = TransactionsPollRequest;
export type PollDailyTransactionsMutationError = unknown;

export const usePollDailyTransactions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pollDailyTransactions>>,
    TError,
    { data: TransactionsPollRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof pollDailyTransactions>>,
  TError,
  { data: TransactionsPollRequest },
  TContext
> => {
  const mutationOptions = getPollDailyTransactionsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const resetFailedPollingPeriods = () => {
  return customInstance<void>({
    url: `/operations/hsbc/statement/transactions/poll/reset`,
    method: 'POST',
  });
};

export const getResetFailedPollingPeriodsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetFailedPollingPeriods>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetFailedPollingPeriods>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetFailedPollingPeriods>>,
    void
  > = () => {
    return resetFailedPollingPeriods();
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetFailedPollingPeriodsMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetFailedPollingPeriods>>
>;

export type ResetFailedPollingPeriodsMutationError = unknown;

export const useResetFailedPollingPeriods = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetFailedPollingPeriods>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetFailedPollingPeriods>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getResetFailedPollingPeriodsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const processStatementLines = () => {
  return customInstance<void>({
    url: `/operations/hsbc/statement/transactions/process`,
    method: 'POST',
  });
};

export const getProcessStatementLinesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processStatementLines>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processStatementLines>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processStatementLines>>,
    void
  > = () => {
    return processStatementLines();
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessStatementLinesMutationResult = NonNullable<
  Awaited<ReturnType<typeof processStatementLines>>
>;

export type ProcessStatementLinesMutationError = unknown;

export const useProcessStatementLines = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processStatementLines>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processStatementLines>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getProcessStatementLinesMutationOptions(options);

  return useMutation(mutationOptions);
};
